import { Suspense } from "react";

import Icon from "@mui/material/Icon";
import {
  SUPER_ADMIN_ROLE,
  SUPERVISEUR_ROLE,
  ADMIN_PAYS_ROLE,
  ADMIN_DIRECTION_ROLE,
  ADMIN_SOUS_SECTEUR_ROLE,
  ADMIN_REGION_ROLE,
  ADMIN_DEPARTEMENTAL_ROLE,
  RESPONSABLE_FERME,
} from "constant/role";
import SuspenceComponent from "components/SuspenceComponent";

export const buildRouteChildren = ({ title, key, path, component: Component }) => ({
  name: <span style={{ color: "black" }}>{title}</span>,
  key,
  route: path,
  component: (
    <Suspense fallback={<SuspenceComponent />}>
      <Component />
    </Suspense>
  ),
  collapse: [],
});

export const buildRouteItem = (title, key, path, ROUTES_DATA, iconName) => {
  return {
    type: "collapse",
    name: <span style={{ color: "black" }}>{title}</span>,
    key,
    icon: (
      <Icon fontSize="small" style={{ color: "black" }}>
        {iconName}
      </Icon>
    ),
    route: path,

    role: [
      SUPER_ADMIN_ROLE,
      SUPERVISEUR_ROLE,
      ADMIN_PAYS_ROLE,
      ADMIN_DIRECTION_ROLE,
      ADMIN_SOUS_SECTEUR_ROLE,
      ADMIN_REGION_ROLE,
      ADMIN_DEPARTEMENTAL_ROLE,
      RESPONSABLE_FERME,
    ],
    /* component: (
      <Suspense fallback={<SuspenceComponent />}>
        <LotIntrant />
      </Suspense>
    ), */

    collapse: ROUTES_DATA.map(buildRouteChildren),
  };
};
